import { isAfter, isBefore, isValid, parse } from 'date-fns';
import getTranslation from '../../../helpers/get-translation';
import { AddAuthUserInputType } from '../../../typings';
var stringHasOnlyLetters = function (value) {
    // Match a single character not present in the group [a-zA-Z]
    return !/[^ a-zA-Z]/.test(value);
};
var validateDate = function (dateInput) {
    var regexDate = /^\d{2}\/\d{2}\/\d{4}$/;
    var parsedDate = parse(dateInput, 'MM/dd/yyyy', new Date());
    return !regexDate.test(dateInput) || !isValid(parsedDate);
};
export var validateDateInput = function (dob) {
    var inputErrorTypeText = getTranslation().inputErrorTypeText;
    if (validateDate(dob)) {
        return inputErrorTypeText.authorizedUserInvalidBirthDate;
    }
    var parsedDate = parse(dob, 'MM/dd/yyyy', new Date());
    var oldestDate = new Date(1900, 0, 1);
    if (isBefore(parsedDate, oldestDate)) {
        return inputErrorTypeText.authorizedUserPastBirthYear;
    }
    if (isAfter(parsedDate, new Date())) {
        return inputErrorTypeText.authorizedUserFutureBirthYear;
    }
    return '';
};
var getInputErrorMessage = function (type, value) {
    var _a = getTranslation(), inputErrorTypeText = _a.inputErrorTypeText, inputTypeHelpText = _a.inputTypeHelpText;
    if (value.trim() === '') {
        return inputTypeHelpText[type];
    }
    if (type === AddAuthUserInputType.authorizedUserBirthDate) {
        return validateDateInput(value);
    }
    if ((type === AddAuthUserInputType.authorizedUserFirstName ||
        type === AddAuthUserInputType.authorizedUserLastName) &&
        !stringHasOnlyLetters(value)) {
        return inputErrorTypeText[type];
    }
    return '';
};
export default getInputErrorMessage;
